import * as React from "react";
import {User} from "../../../generated/protocol";
import {DeleteButtonModal} from "../util/DeleteButtonModal";


interface Props {
    user: User;
    onMutePlayer?: () => Promise<any>;
    onUnMutePlayer?: () => Promise<any>;
}

export class UserActions extends React.Component<Props, {}> {


    getEdit() {
        if (this.props.user.status == "ENABLED") {
            return <button type="button" className="btn btn-w-m btn-primary disabled"><i
                className="fa fa-edit"></i> Edit User</button>
        }
        return false;
    }

    getBlockOrUnblock() {
        if (this.props.user.status == "ENABLED") {
            return <button type="button" className="btn btn-w-m btn-danger disabled"><i className="fa fa-ban"></i> Block
                User</button>;
        } else {
            return <button type="button" className="btn btn-w-m btn-primary disabled"><i
                className="fa fa-thumbs-up"></i> Unblock User</button>
        }
    }

    getMuteOrUnMute() {
        if (this.props.user.attributes["MUTED"] === "true") {
            return (
                <div>
                    <DeleteButtonModal className="btn btn-primary" label="Allow Player to Chat"
                                       onDelete={this.props.onUnMutePlayer}/>
                    <span> Player is currently blocked in chat.</span>
                </div>
            );
        } else {
            return <DeleteButtonModal className="btn btn-danger" label="Block Player in Chat"
                                      onDelete={this.props.onMutePlayer}/>
        }
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="ibox">
                    <div className="ibox-content">
                        <h2>Manage</h2>
                        {this.getMuteOrUnMute()}
                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/user/UserActions.tsx